import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App";
import routes from "./routes/routes";
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import Notifications from "./components/NotificationPlugin";
import MaterialDashboard from "./material-dashboard";
// import "jsuites/dist/jsuites.css";
import Chartist from "chartist";
const router = new VueRouter({
  routes, // short for routes: routes
  linkExactActiveClass: "active"
});

// import VueRx from 'vue-rx';
// import { Observable } from "rxjs/Observable";
// Vue.use(VueRx,{Observable});

import "./assets/global.css";
import "./assets/main.css";
import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);
import VueSession from "vue-session";
Vue.use(VueSession);

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts)

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
Vue.component("v-select", vSelect);

import Vuex from "vuex";
Vue.use(Vuex);
import { store } from "./store";

// import Autocomplete from 'v-autocomplete'
// import 'v-autocomplete/dist/v-autocomplete.css'
// Vue.use(Autocomplete)

import { BootstrapVue, componentsPlugin, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
import VueSidebarMenu from "vue-sidebar-menu";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";
import i18n from "./i18n";
Vue.use(VueSidebarMenu);
Vue.prototype.$Chartist = Chartist;
Vue.use(VueRouter);
Vue.use(MaterialDashboard);
Vue.use(GlobalComponents);
Vue.use(GlobalDirectives);
Vue.use(Notifications);
import VueTouchKeyboard from "vue-touch-keyboard";
import "vue-touch-keyboard/dist/vue-touch-keyboard.css"; // load default style
Vue.use(VueTouchKeyboard);
Vue.filter("numFormat", function (value) {
  if (typeof value !== "number") {
    value = parseFloat(value);
  }

  if (isNaN(value)) return "";

  const valueStr = value.toString();
  const decimalPart = valueStr.split(".")[1];
  const fractionLength = decimalPart ? Math.min(decimalPart.length, 3) : 0;

  return new Intl.NumberFormat("ru-RU", {
    style: "decimal",
    minimumFractionDigits: fractionLength,
    maximumFractionDigits: 3,
    useGrouping: true
  }).format(value);
});

Vue.filter("numFormatbutun", function (value) {
  if (typeof value !== "number") {
    value = parseFloat(value);
  }

  if (isNaN(value)) return "";

  // Agar butun son bo‘lsa, kasr qismini ko‘rsatmaymiz
  const hasDecimal = value % 1 !== 0;

  return new Intl.NumberFormat("ru-RU", {
    style: "decimal",
    minimumFractionDigits: hasDecimal ? 2 : 0,
    maximumFractionDigits: 2,
    useGrouping: true
  })
    .format(value);
});
Vue.filter("numFormatuniversal", function (value) {
  if (typeof value !== "number") {
    value = parseFloat(value);
  }

  if (isNaN(value)) return "";

  const valueStr = value.toString();
  const decimalPart = valueStr.split(".")[1];
  const fractionLength = decimalPart ? Math.min(decimalPart.length, 3) : 0;

  return new Intl.NumberFormat("ru-RU", {
    style: "decimal",
    minimumFractionDigits: fractionLength,
    maximumFractionDigits: 3,
    useGrouping: true
  }).format(value);
});
Vue.filter("numFormats", function (value) {
  if (typeof value !== "number") {
    value = parseFloat(value);
  }

  if (isNaN(value)) return "";

  const valueStr = value.toString();
  const decimalPart = valueStr.split(".")[1];
  const fractionLength = decimalPart ? Math.min(decimalPart.length, 3) : 0;

  var val = new Intl.NumberFormat("ru-RU", {
    style: "decimal",
    minimumFractionDigits: fractionLength,
    maximumFractionDigits: 3,
    useGrouping: true
  }).format(value);
  var vall = val.replace(',', '.');
  if (store.state.xls == false) {
    return vall;
  } else {
    if (value != null) {
      return parseFloat(value).toFixed(2);
    } else {
      return 0;
    }
  }
});

Vue.filter("numFormatss", function (value) {
  var val = new Intl.NumberFormat("ru-RU", {
    maximumFractionDigits: 2
  }).format(value);
  var vall = val.replace(',', '.');
  if (store.state.xls == false) {
    return vall;
  } else {
    if (value != null) {
      return parseFloat(value).toFixed(2);
    } else {
      return 0;
    }
  }
});
Vue.filter("numFormats0", function (value) {
  var val = new Intl.NumberFormat("ru-RU", {
    maximumFractionDigits: 0
  }).format(value);
  var vall = val.replace(',', '.');
  if (store.state.xls == false) {
    return vall;
  } else {
    return parseFloat(value).toFixed(2);
  }
});
import numeral from 'numeral'
numeral.register('locale', 'cl', {
  delimiters: {
    thousands: ' ',
    decimal: '.'
  },
  abbreviations: {
    thousand: 'm',
    million: 'M',
    billion: 'B',
    trillion: 'T'
  },
  ordinal: function (number) {
    return number === 1 ? 'er' : 'ème'
  },
  currency: {
    symbol: '$'
  }
})

// switch between locales
numeral.locale('cl');
Vue.filter('formatNumberMoney', function (value) {
  return numeral(value).format('0,0.00')
  // displaying other groupings/separators is possible, look at the docs
})
Vue.filter("numFormat0", function (value) {
  return new Intl.NumberFormat("ru-RU", {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value);
});
Vue.filter("numFormat3", function (value) {
  return new Intl.NumberFormat("ru-RU", {
    style: "decimal",
    minimumFractionDigits: 3,
    maximumFractionDigits: 3
  }).format(value);
});

// import "ag-grid-community/dist/styles/ag-grid.css";
// import "ag-grid-community/dist/styles/ag-theme-alpine.css";

import VueNumeric from "vue-numeric";
Vue.use(VueNumeric);
import VueSimpleAlert from "vue-simple-alert";
if (localStorage.getItem('ruleindex') == undefined || localStorage.getItem('ruleindex') == null) {
  localStorage.setItem('ruleindex', 1);
}
Vue.use(VueSimpleAlert);
window.axios = require("axios");
window.axios.defaults.baseURL = process.env.VUE_APP_BASE_URL; 
if (localStorage.getItem("token") == undefined || localStorage.getItem("token") != null) {
  router.push("/login");
}
window.axios.interceptors.request.use(req => {
  req.headers.authorization = "Bearer " + localStorage.getItem("token");
  req.headers['content-type'] = "application/json";
  req.headers["Accept-Language"] = "uz";
  return req;
});
window.axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response == undefined) {
      store.state.errors = 'Baza bilan aloqa o`rnatilinmoqda';
    }
    else if (error.response.status == 401) {
      // store.state.errors = 'Foydalanish vaqti tugagan, Login va parolni kiriting';
      // localStorage.removeItem("user_id");
      // localStorage.removeItem("sklad_id");
      // localStorage.removeItem("token");
      // console.log(error.response.data.message);
      if (error.response.data.message) {
        store.state.errors = error.response.data.message;
      }
      router.push("/login");
    } else if (error.response.status == 400) {
      if (error.response.data.errors[0].msg) {
        store.state.errors = error.response.data.errors[0].msg;
      } else {
        store.state.errors =
          error.response.data.errors[0].row +
          " қатор " +
          error.response.data.errors[0].column +
          "ни тўлдиринг";
      }
    } else if (error.response.status == 404) {
      // if (window.axios.defaults.baseURL == undefined) {
      //   router.push("/sendsms");
      // } else {
      if (!error.response.data.message) {
        store.state.errors = error.response.data;
      } else {
        store.state.errors = error.response.data.message;
      }
      console.log(error.response.data);
      // store.state.errors ='Сахифа топилмади';
      // }
    }
    else if (error.response.status == 405) {
      store.state.errors = error.response.data;
      router.push("/sendsms");
    } else if (error.response.data.message) {
      store.state.errors = error.response.data.message;
    } else {
      store.state.errors = error.response.data;
    }
    console.log(error.response);
    return Promise.reject(error);
  }
);
new Vue({
  el: "#app",
  render: h => h(App),
  store,
  i18n,
  router
});